import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "resendProjectAcknowledgement",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Resend Project Acknowledgement ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, "Date :", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createVNode("strong", null, "Reason :", -1)
const _hoisted_14 = { action: "#" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "" }, "Payer Emails", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus-circle mr-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Add Email ")
const _hoisted_22 = { class: "col-md-12" }
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "" }, "Name", -1)
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { for: "" }, "Estimation $", -1)
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { for: "" }, "Details", -1)
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { for: "" }, "Start Date", -1)
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "" }, "End Date", -1)
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", { for: "" }, "Attachements (Docs)", -1)
const _hoisted_43 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_44 = { class: "row mx-n2" }
const _hoisted_45 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_46 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_49 = { class: "imaged-col" }
const _hoisted_50 = { class: "small-img-wrap" }
const _hoisted_51 = { class: "size" }
const _hoisted_52 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_53 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_56 = { class: "imaged-col" }
const _hoisted_57 = { class: "small-img-wrap" }
const _hoisted_58 = { class: "size" }
const _hoisted_59 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_60 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_63 = { class: "imaged-col" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_65 = { class: "size" }
const _hoisted_66 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_67 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "centered-wrap" }, [
  /*#__PURE__*/_createVNode("span", {
    class: "spinner-border big-spinner",
    role: "status"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
  ])
], -1)
const _hoisted_69 = { class: "size" }
const _hoisted_70 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("p", null, "OR")
], -1)
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = /*#__PURE__*/_createVNode("label", { for: "" }, "Edoc Link", -1)
const _hoisted_74 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideProjectAcknowledgementModal && _ctx.hideProjectAcknowledgementModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.errors.errorList.approval,
              hasError: _ctx.state.ui.errors.hasError
            }, null, 8, ["errors", "hasError"]),
            (_ctx.selectedDecline.created_at && _ctx.selectedDecline.description)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  (_ctx.selectedDecline)
                    ? (_openBlock(), _createBlock("p", _hoisted_10, [
                        _hoisted_11,
                        _createTextVNode(" " + _toDisplayString(_ctx.selectedDecline.created_at), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedDecline)
                    ? (_openBlock(), _createBlock("p", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(_ctx.selectedDecline.description), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode("form", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addPayers && _ctx.addPayers(...args)), ["enter"])),
                      placeholder: "Type email and press enter or click add button",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.projectAckowledgement.payer = $event))
                    }, null, 544), [
                      [_vModelText, _ctx.state.data.projectAckowledgement.payer]
                    ])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-soft-success mt-md-0 mt-2",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addPayers && _ctx.addPayers(...args)))
                    }, [
                      _hoisted_20,
                      _hoisted_21
                    ])
                  ]),
                  _createVNode("div", _hoisted_22, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectAckowledgement.payers, (payer, payerIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        key: payerIndex,
                        class: "email-tag"
                      }, [
                        _createVNode("p", _hoisted_23, [
                          _createTextVNode(_toDisplayString(payer) + " ", 1),
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.removeSelectedUser(payer))
                          }, [
                            _hoisted_24
                          ], 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createVNode("input", {
                      disabled: "",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.projectAckowledgement.name = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.projectAckowledgement.name]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _withDirectives(_createVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.projectAckowledgement.estimatedBudget = $event)),
                      min: "1",
                      placeholder: "eg. 5321"
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.projectAckowledgement.estimatedBudget]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  rows: "6",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.projectAckowledgement.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectAckowledgement.description]
                ])
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createVNode("input", {
                      type: "date",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.projectAckowledgement.startDate = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.projectAckowledgement.startDate]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _withDirectives(_createVNode("input", {
                      type: "date",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.projectAckowledgement.endDate = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.projectAckowledgement.endDate]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(_component_DragAndDropZone, {
                  onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
                  onDropFiles: _ctx.dropFiles
                }, null, 8, ["onDrop", "onDropFiles"]),
                (
                    _ctx.state.data.projectAckowledgement.attachments &&
                    _ctx.state.data.projectAckowledgement.attachments.length
                  )
                  ? (_openBlock(), _createBlock("div", _hoisted_43, [
                      _createVNode("div", _hoisted_44, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectAckowledgement.attachments, (image, imageIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "col-sm-6",
                            key: imageIndex
                          }, [
                            (
                          image.extension === 'jpg' ||
                          image.extension === 'png' ||
                          image.extension === 'jpeg' ||
                          image.extension === 'gif'
                        )
                              ? (_openBlock(), _createBlock("div", _hoisted_45, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_46, [
                                        _hoisted_47
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_48
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_49, [
                                    _createVNode("div", _hoisted_50, [
                                      _createVNode("img", {
                                        src: image.file,
                                        alt: "",
                                        height: "200"
                                      }, null, 8, ["src"])
                                    ]),
                                    _createVNode("h5", null, _toDisplayString(image.name), 1),
                                    _createVNode("p", _hoisted_51, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (image.extension === 'pdf')
                              ? (_openBlock(), _createBlock("div", _hoisted_52, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_53, [
                                        _hoisted_54
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_55
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_56, [
                                    _createVNode("div", _hoisted_57, [
                                      _createVNode("img", {
                                        src: 
                                _ctx.state.data.imageBaseUrl
                                  ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                                  : 'img/pdf.jpg'
                              ,
                                        alt: ""
                                      }, null, 8, ["src"])
                                    ]),
                                    _createVNode("h5", null, _toDisplayString(image.name), 1),
                                    _createVNode("p", _hoisted_58, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                          image.extension === 'doc' ||
                          image.extension === 'docx'
                        )
                              ? (_openBlock(), _createBlock("div", _hoisted_59, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_60, [
                                        _hoisted_61
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_62
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_63, [
                                    _hoisted_64,
                                    _createVNode("h5", null, _toDisplayString(image.name), 1),
                                    _createVNode("p", _hoisted_65, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                          image.extension === 'mp4' ||
                          image.extension === 'mov' ||
                          image.extension === 'MOV' ||
                          image.extension === 'wmv' ||
                          image.extension === 'webm' ||
                          image.extension === 'ogg' ||
                          image.extension === 'avi' ||
                          image.extension === 'x-ms-wmv'
                        )
                              ? (_openBlock(), _createBlock("div", _hoisted_66, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_67, [
                                        _hoisted_68
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("img", {
                                    src: 
                            _ctx.state.data.imageBaseUrl
                              ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                              : 'img/video-icon.png'
                          ,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"]),
                                  _createVNode("h5", null, _toDisplayString(image.name), 1),
                                  _createVNode("p", _hoisted_69, _toDisplayString(image.size), 1),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_70
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_71,
              _createVNode("div", _hoisted_72, [
                _hoisted_73,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.projectAckowledgement.edocLink = $event)),
                  placeholder: "https://qa.convorally.com"
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectAckowledgement.edocLink]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_74, [
            _createVNode(_component_Button, {
              buttonName: _ctx.state.data.buttonName,
              buttonLoading: _ctx.state.ui.isPostLoading.acknowledgeRequest,
              onButtonTrigger: _ctx.acknowledgeRequest
            }, null, 8, ["buttonName", "buttonLoading", "onButtonTrigger"]),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideProjectAcknowledgementModal && _ctx.hideProjectAcknowledgementModal(...args)))
            }, " Cancel ")
          ])
        ])
      ])
    ])
  ]))
}